import { useEffect } from 'react';
import '@n8n/chat/style.css';
import { createChat } from '@n8n/chat';

export default function Chatbot() {
  useEffect(() => {
    createChat({
      webhookUrl: 'https://n8n.srv982642.hstgr.cloud/webhook/b8e8d6c3-0d29-4dd5-a505-e0fcfab2ba93/chat',
      mode: 'window',
      showWelcomeScreen: true,
      initialMessages: [
        'Hello, I am Deep. How can I help you?'
      ],
      i18n: {
        en: {
          title: 'Chat with Deep',
          subtitle: "I'm here to help you with travel planning and Answer Queries related to VacayPlanner",
          inputPlaceholder: 'Type your message...',
          getStarted: 'Start New Chat'
        },
      },
    });
  }, []);

  return <div id="n8n-chat"></div>;
}
